/**
 * Retries a dynamic import a few times before giving up, so a chunk that fails to load once - a
 * stale chunk right after a deploy, a flaky connection - does not take the whole route down.
 */
export default function retry(fn: any, retriesLeft = 3, interval = 700): Promise<any> {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: any) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}
